import { AppointmentsFeatureId, AppointmentsClientSideFeatureId, AppointmentsPlanToken } from './types/features';

// FREE_TRIAL is used for features that are part of a merchant's current free trial plan
// PAYWALL is used for features that are part of a higher tier plan than a merchant's current non-free-trial plan
export let UPSELL_TYPE = /*#__PURE__*/function (UPSELL_TYPE) {
  UPSELL_TYPE["FREE_TRIAL"] = "FREE_TRIAL";
  UPSELL_TYPE["PAYWALL"] = "PAYWALL";
  return UPSELL_TYPE;
}({});
export const FEATURE_DETAILS = {
  [AppointmentsFeatureId.APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.COMMISSION_TRACKING]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_DAILY_RESERVATION_LIMIT]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: false
  },
  [AppointmentsFeatureId.APPOINTMENTS_GOOGLE_CALENDAR_SYNC]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: false
  },
  [AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: false
  },
  [AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.EMPLOYEE_MANAGEMENT]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.CONTRACTS_CUSTOM_FIELDS]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_WAITLIST]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsClientSideFeatureId.ADVANCED_STAFF_MANAGEMENT]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: false
  },
  [AppointmentsFeatureId.APPOINTMENTS_REPORTING]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsClientSideFeatureId.CUSTOM_PRICING]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN,
    hasMoreDetails: false
  },
  [AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_TEAM_PERFORMANCE]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_FUTURE_BOOKINGS]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  },
  [AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS]: {
    planToken: AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN,
    hasMoreDetails: true
  }
};
export let WorkflowState = /*#__PURE__*/function (WorkflowState) {
  WorkflowState["DEFAULT"] = "DEFAULT";
  WorkflowState["MIGRATING"] = "MIGRATING";
  WorkflowState["ONBOARDING"] = "ONBOARDING";
  WorkflowState["UNSUBSCRIBED"] = "UNSUBSCRIBED";
  WorkflowState["UPGRADING"] = "UPGRADING";
  return WorkflowState;
}({});